module.exports = __webpack_public_path__ + "static/media/entregarinju2.4fb69bb1.jpg";